import React from "react";
import * as XLSX from "xlsx";

const DownloadExcelFromTable = ({ tableRef, fileName = "table_data.xlsx" }) => {
  const handleDownload = () => {
    try {
      if (!tableRef?.current) {
        alert("Table reference not found!");
        return;
      }

      const originalTable = tableRef.current;
      const clonedTable = originalTable.cloneNode(true);

      // FIX SELECT
      const originalSelects = originalTable.querySelectorAll("select");
      const clonedSelects = clonedTable.querySelectorAll("select");

      originalSelects.forEach((select, i) => {
        const td = clonedSelects[i]?.closest("td");
        if (td) td.textContent = select.value || "";
      });

      // FIX INPUT
      const originalInputs = originalTable.querySelectorAll("input");
      const clonedInputs = clonedTable.querySelectorAll("input");

      originalInputs.forEach((input, i) => {
        const td = clonedInputs[i]?.closest("td");
        if (!td) return;

        td.textContent =
          input.type === "checkbox"
            ? input.checked
              ? "Yes"
              : "No"
            : input.value || "";
      });

      // FIND DATE COLUMN FROM HEADER
      const headerRow = clonedTable.querySelector("thead tr");

      let dateColumnIndex = -1;

      if (headerRow) {
        const headers = Array.from(headerRow.cells);

        dateColumnIndex = headers.findIndex(
          (cell) => cell.textContent.trim().toLowerCase() === "date",
        );
      }

      // SAVE ORIGINAL DISPLAYED DATE VALUES
      const originalDates = [];

      if (dateColumnIndex !== -1) {
        const rows = Array.from(clonedTable.rows);

        rows.forEach((row, rowIndex) => {
          if (rowIndex === 0) return; // Header

          const dateCell = row.cells[dateColumnIndex];

          if (dateCell) {
            originalDates.push({
              rowIndex,
              value: dateCell.textContent.trim(),
            });
          }
        });
      }

      // CONVERT TABLE
      const worksheet = XLSX.utils.table_to_sheet(clonedTable);

      // FORCE DATE CELLS TO TEXT
      if (dateColumnIndex !== -1) {
        originalDates.forEach(({ rowIndex, value }) => {
          const address = XLSX.utils.encode_cell({
            r: rowIndex,
            c: dateColumnIndex,
          });

          worksheet[address] = {
            t: "s",
            v: value,
          };
        });
      }

      // CREATE WORKBOOK
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // EXPORT
      const buffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`;

      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error("Excel export error:", err);
      alert("Excel export failed");
    }
  };

  return (
    <div className="d-flex justify-content-end">
      <button
        type="button"
        onClick={handleDownload}
        className="btn btn-sm btn-outline-success"
      >
        Download Excel
      </button>
    </div>
  );
};

export default DownloadExcelFromTable;
